import { render, staticRenderFns } from "./querstionItem.vue?vue&type=template&id=5f79002c&scoped=true"
import script from "./querstionItem.vue?vue&type=script&lang=js"
export * from "./querstionItem.vue?vue&type=script&lang=js"
import style0 from "./querstionItem.vue?vue&type=style&index=0&id=5f79002c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f79002c",
  null
  
)

export default component.exports